export default "__VITE_PUBLIC_ASSET__019f4c5b__"